<template>
  <!-- <autocomplete
    ref="autocomplete"
    :base-class="baseClass"
    v-bind="{ ...$props, ...$attrs }"
    @submit="handleSubmit"
    v-on:input="handleInput"
  ></autocomplete> -->
  <div v-if="searchClient">
    <ais-instant-search
      :search-client="searchClient"
      :index-name="algoliaIndex"
    >
      <ais-autocomplete>
        <div slot-scope="{ currentRefinement, indices, refine }">
          <b-input-group>
            <b-form-input
              ref="search"
              type="search"
              class="rounded"
              :size="size"
              v-model="selected"
              :placeholder="placeholder"
              @input="
                refine($event);
                showResults();
              "
            />
            <b-input-group-append>
              <b-dropdown
                toggle-class="{ d-none }"
                :menu-class="{ show: currentRefinement && showDropdown }"
                right
                v-if="!embed"
              >
                <div v-if="currentRefinement" :style="{ width: menuWidth }">
                  <b-dropdown-item
                    v-for="hit in indices[0].hits"
                    :key="hit.objectID"
                    @click="handleClick(hit)"
                  >
                    <ais-highlight :attribute="display" :hit="hit" />
                  </b-dropdown-item>
                </div>
                <b-dropdown-header>
                  <ais-powered-by />
                </b-dropdown-header>
              </b-dropdown>
            </b-input-group-append>
          </b-input-group>
          <b-list-group v-if="embed" class="mt-2">
            <b-list-group-item
              button
              v-for="hit in indices[0].hits"
              :key="hit.objectID"
              @click="handleClick(hit)"
            >
              <ais-highlight :attribute="display" :hit="hit" />
            </b-list-group-item>
          </b-list-group>
        </div>
      </ais-autocomplete>
    </ais-instant-search>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import algoliasearch from "algoliasearch/lite";

export default {
  name: "AlgoliaAutocomplete",
  props: {
    searchIndex: {
      type: String,
      required: false,
      default: "Users",
    },
    overwriteClass: {
      type: String,
      required: false,
    },
    placeholder: {
      type: String,
      required: false,
      default: "e.g. John Smith",
    },
    display: {
      type: String,
      required: false,
      default: "name",
    },
    size: {
      type: String,
      required: false,
      default: "md",
    },
    value: {
      type: String,
      required: false,
      default: "",
    },
    embed: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      searchClient: false,
      selectedValue: null,
      showDropdown: false,
      selected: "",
      menuWidth: "300px",
    };
  },
  watch: {
    searchKey: {
      immediate: true,
      handler() {
        const config = this.searchConfig;
        if (
          config &&
          typeof config.app_id === "string" &&
          config.app_id.length > 0
        ) {
          // Initialize Algolia
          this.searchClient = algoliasearch(config.app_id, config.search_key);
        }
      },
    },
    value: {
      immediate: true,
      handler(value) {
        if (typeof value === "string" && value.length > 0) {
          this.selected = this.value;
        }
      },
    },
  },
  computed: {
    ...mapGetters(["searchConfig"]),
    algoliaIndex() {
      return window.environment === "sandbox"
        ? "sandbox_" + this.searchIndex
        : "prod_" + this.searchIndex;
    },
    searchKey() {
      return this.searchConfig.search_key;
    },
    baseClass() {
      return this.overwriteClass ? this.overwriteClass : "autocomplete";
    },
  },
  methods: {
    showResults() {
      this.showDropdown = true;
      const width = this.$refs.search.$el.offsetWidth;
      this.menuWidth = width + "px";
    },
    showCurrentValue(refinement) {
      console.log(
        "Selected",
        this.selected,
        typeof this.selected === "string" && this.selected.length > 0
      );
      return typeof this.selected === "string" && this.selected.length > 0
        ? this.selected
        : refinement;
    },
    handleClick(selected) {
      this.showDropdown = false;
      console.log("Selected", this.selected);
      this.selected = selected[this.display];
      this.$emit("change", selected);
    },
  },
};
</script>
